/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Session_Edit_In_StudioInputs */

const en_ui_session_edit_in_studio = /** @type {(inputs: Ui_Session_Edit_In_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit route in Studio`)
};

const de_ui_session_edit_in_studio = /** @type {(inputs: Ui_Session_Edit_In_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route im Studio bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit route in Studio" |
*
* @param {Ui_Session_Edit_In_StudioInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_edit_in_studio = /** @type {((inputs?: Ui_Session_Edit_In_StudioInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_Edit_In_StudioInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_edit_in_studio(inputs)
	return de_ui_session_edit_in_studio(inputs)
});